import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import './Utils/forceLogout'; // Make forceLogout available globally

const App = React.lazy(() => import(/* webpackChunkName: "App" */'./App' ));

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement, {
  onCaughtError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <Provider store={configureStore()}>
    <Sentry.ErrorBoundary fallback={<div className="loading" />}>
      <Suspense fallback={<div className="loading" />}>
        <App />
      </Suspense>
    </Sentry.ErrorBoundary>
  </Provider>
);
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
